import { useRef, useEffect, useState } from 'react';
import hasPassiveEvent from 'has-passive-events';
const INITIAL_POSITION = { x: 0, y: 0, left: 0, top: 0, scrollLeft: 0, scrollTop: 0 };
/* istanbul ignore next */
const EVENT_OPTIONS = hasPassiveEvent ? { passive: true } : false;
const getScrollPosition = (element) => {
    const { scrollTop, scrollLeft } = element;
    return {
        scrollLeft,
        scrollTop,
        x: scrollLeft,
        y: scrollTop,
        left: scrollLeft,
        top: scrollTop,
    };
};
export function useScrollPosition(element) {
    const rafTick = useRef(0);
    const [position, setPosition] = useState(INITIAL_POSITION);
    useEffect(() => {
        if (element === null) {
            return;
        }
        const target = element === undefined ? document.documentElement : element;
        setPosition(getScrollPosition(target));
        const syncScroll = () => {
            if (rafTick.current) {
                return;
            }
            const callback = () => {
                setPosition(getScrollPosition(target));
                rafTick.current = 0;
            };
            rafTick.current = requestAnimationFrame(callback);
        };
        target.addEventListener('scroll', syncScroll, EVENT_OPTIONS);
        return () => {
            target.removeEventListener('scroll', syncScroll, EVENT_OPTIONS);
            cancelAnimationFrame(rafTick.current);
        };
    }, [element]);
    return position;
}
export function useScrollTop(element) {
    const { scrollTop } = useScrollPosition(element);
    return scrollTop;
}
export function useScrollLeft(element) {
    const { scrollLeft } = useScrollPosition(element);
    return scrollLeft;
}
//# sourceMappingURL=index.js.map